import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiHelper } from 'cad/common/services/api/api-helper';
import * as _ from 'lodash';
import { DataPurgeHold } from 'src/cad/administration/table-maintenance/data-purge/shared/interfaces/data-purge-hold';
import { DataPurgeHoldHistory } from 'src/cad/administration/table-maintenance/data-purge/shared/interfaces/data-purge-hold-history';
import ValidationResult = cad.ValidationResult;

@Injectable()
export class TableMaintenanceDataPurgeHoldApi {

  public readonly endpoint: string = 'administration/table-maintenance/data-purge';

  constructor(
    private apiHelper: ApiHelper
  ) { }

  public getAssetsWithLockStatus(): Observable<DataPurgeHold[]> {
    return this.apiHelper.request(this.endpoint + '/asset-locks-status');
  }

  public getAssetLockHistory(assetNbr: number): Observable<DataPurgeHoldHistory[]> {
    return this.apiHelper.request(this.endpoint + `/asset-locks-history/${assetNbr}`);
  }

  public saveDataPurgeHold(params: DataPurgeHold[]): Observable<ValidationResult<DataPurgeHold[]>> {
    return this.apiHelper.request(this.endpoint + '/save', {body: params});
  }

}
